// import { useMachine } from "@xstate/react";
// import { defineOwnDataMachine } from "../machines";
import { DefineDirections } from "./DefineData/DefineDirections";
import { DefineBins } from "./DefineData/DefineBins";
import { useActor } from "@xstate/react";

const DefineDataPatternMatcher = ({ current, send }) => {
  const isCardinal = current.matches("selectDirections.cardinal");
  const isUniformBins = current.matches("selectBins.uniform");

  switch (true) {
    case current.matches("selectDirections"):
      return (
        <DefineDirections
          isCardinal={isCardinal}
          directions={current.context.directions}
          onSetDirections={(directions) =>
            send({ type: "SET_DIRECTIONS", directions })
          }
          onToggleCardinal={() => send("TOGGLE_CARDINAL")}
          onConfirmDirections={() => send("CONFIRM_DIRECTIONS")}
        />
      );
    case current.matches("selectBins"):
      return (
        <DefineBins
          isUniformBins={isUniformBins}
          bins={current.context.bins}
          onToggleUniformBins={() => send("TOGGLE_UNIFORM")}
          onSetBins={(bins) => send({ type: "SET_BINS", bins })}
          onGoBackDirection={() => send("GO_BACK_DIRECTIONS")}
          onConfirmBins={() => send("CONFIRM_BINS")}
        />
      );
    case current.matches("confirmOwnData"):
      return (
        <div>
          <h3 class="h3">Confirm directions and bins</h3>
          <ul class="list-disc">
            <li>
              <span class="font-bold">Directions</span>:{" "}
              {current.context.directions.join(", ")}
            </li>
            <li>
              <span class="font-bold">Bins</span>:
              {current.context.bins.join(", ")}
            </li>
          </ul>

          <div class="flex justify-end pt-2">
            <button
              class="btn btn-blue mr-4"
              onClick={() => send("GO_BACK_BINS")}
            >
              Go back
            </button>
            <button
              class="btn btn-blue"
              onClick={() => send("CONFIRM_OWN_DATA")}
            >
              Confirm data
            </button>
          </div>
        </div>
      );
    default:
      return <div>Hmmm, not right</div>
  }
};

function DefineData({ defineOwnDataMachine }) {
  const [current, send] = useActor(defineOwnDataMachine);

  return (
    <div class="define-data-card">
      <h2 class="h2">Define your own data</h2>
      <p class="my-4">Define the directions and bins to get started</p>
      <DefineDataPatternMatcher current={current} send={send} />
    </div>
  );
}

export { DefineData };
